import {getFromServer} from "~/composables/getFromServer.js";
import {getFromClient} from "~/composables/getFromClient.js";

export async function getFromAny(url, opts = []) {
    if (process.server) {
        return getFromServer(url, opts);
    }

    return getFromClient(url, opts);
}
